import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TooltipModule } from 'primeng/tooltip';
import { MessageService, ConfirmationService } from 'primeng/api';
import { TipoEnvioService } from '../../../core/services/tipo-envio.service';
import { TipoEnvio } from '../../../shared/models/system';

@Component({
  selector: 'app-tipo-envio-admin',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './tipo-envio-admin.html',
  styleUrls: ['./tipo-envio-admin.css']
})
export class TipoEnvioAdminComponent implements OnInit {
  list: TipoEnvio[] = [];
  item: Partial<TipoEnvio> = {};
  dialog: boolean = false;
  submitted: boolean = false;

  constructor(
    private service: TipoEnvioService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.service.getAll().subscribe({
      next: (data) => {
        this.list = data;
        this.cdr.detectChanges();
      }
    });
  }

  openNew() {
    this.item = { isActive: true, isNational: false, precio: 0 };
    this.submitted = false;
    this.dialog = true;
  }

  edit(row: TipoEnvio) {
    this.item = { ...row };
    this.dialog = true;
  }

  save() {
    this.submitted = true;
    if (this.item.nombreTipoEnvio?.trim()) {
      const req = this.item.id
        ? this.service.update(this.item.id, this.item as TipoEnvio)
        : this.service.create(this.item);
      req.subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Tipo envío guardado' });
          this.load();
          this.dialog = false;
        }
      });
    }
  }

  toggle(row: TipoEnvio) {
    this.confirmationService.confirm({
      message: `¿${row.isActive ? 'Desactivar' : 'Activar'} ${row.nombreTipoEnvio}?`,
      header: 'Confirmar Estado',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.service.toggle(row.id).subscribe(() => this.load());
      }
    });
  }
}
